import { parse } from 'mathjs';

const FIELD_PATTERN = /\[([^\]]+)\]/g;
const ALLOWED_OPERATORS = new Set(['+', '-', '*', '/', '^', '%']);

export const compileBiFormula = (formula, availableFields = null) => {
  if (typeof formula !== 'string' || !formula.trim()) {
    throw new Error('A képlet megadása kötelező!');
  }

  const references = [];
  const referenceIndexes = new Map();
  const expression = formula.replace(FIELD_PATTERN, (_match, fieldName) => {
    const normalizedFieldName = fieldName.trim();

    if (
      !normalizedFieldName ||
      (availableFields && !availableFields.includes(normalizedFieldName))
    ) {
      throw new Error(`Ismeretlen mező a képletben: [${normalizedFieldName}]`);
    }

    if (!referenceIndexes.has(normalizedFieldName)) {
      referenceIndexes.set(normalizedFieldName, references.length);
      references.push(normalizedFieldName);
    }

    return `__biFormulaValue${referenceIndexes.get(normalizedFieldName)}`;
  });

  if (!references.length) {
    throw new Error('A képletnek legalább egy [mező] hivatkozást tartalmaznia kell!');
  }

  let expressionNode;
  try {
    expressionNode = parse(expression);
  } catch (_error) {
    throw new Error('A képlet formátuma hibás!');
  }

  expressionNode.traverse((node) => {
    const isAllowedSymbol =
      node.type === 'SymbolNode' && /^__biFormulaValue\d+$/.test(node.name);
    const isAllowedOperator =
      node.type === 'OperatorNode' && ALLOWED_OPERATORS.has(node.op) && !node.implicit;

    if (
      node.type !== 'ConstantNode' &&
      node.type !== 'ParenthesisNode' &&
      !isAllowedSymbol &&
      !isAllowedOperator
    ) {
      throw new Error('A képletben csak számok, mezők, zárójelek és alapműveletek használhatók!');
    }
  });

  const compiledExpression = expressionNode.compile();

  return {
    references,
    evaluate: (getFieldValue) => {
      const scope = {};

      for (const [fieldName, index] of referenceIndexes) {
        const value = getFieldValue(fieldName);
        if (value === null || value === undefined || value === '') return null;

        const numericValue = Number(value);
        if (!Number.isFinite(numericValue)) return null;

        scope[`__biFormulaValue${index}`] = numericValue;
      }

      try {
        const result = Number(compiledExpression.evaluate(scope));
        return Number.isFinite(result) ? result : null;
      } catch (_error) {
        return null;
      }
    },
  };
};
